export const DrumPortrait = ({ peau = "#D8C9AE", bois = "#5C4033", className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} role="img" aria-label="Tambour artisanal">
    <defs>
      <radialGradient id={`skin-${peau.replace("#", "")}`} cx="42%" cy="36%" r="75%">
        <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.35" />
        <stop offset="55%" stopColor={peau} />
        <stop offset="100%" stopColor={peau} />
      </radialGradient>
    </defs>
    <circle cx="100" cy="100" r="97" fill={bois} />
    <circle cx="100" cy="100" r="97" fill="none" stroke="#2C221E" strokeOpacity="0.35" strokeWidth="2" />
    <circle cx="100" cy="100" r="88" fill={bois} opacity="0.85" />
    <circle cx="100" cy="100" r="80" fill={`url(#skin-${peau.replace("#", "")})`} stroke="#2C221E" strokeOpacity="0.2" strokeWidth="1.5" />
    {Array.from({ length: 12 }).map((_, i) => {
      const a1 = (i / 12) * Math.PI * 2;
      const a2 = ((i + 1.5) / 12) * Math.PI * 2;
      return (
        <line
          key={i}
          x1={100 + Math.cos(a1) * 78}
          y1={100 + Math.sin(a1) * 78}
          x2={100 + Math.cos(a2) * 78}
          y2={100 + Math.sin(a2) * 78}
          stroke={bois}
          strokeOpacity="0.55"
          strokeWidth="2.5"
        />
      );
    })}
    <circle cx="100" cy="100" r="7" fill={bois} opacity="0.8" />
  </svg>
);
